import { ReactNode, createContext } from 'react';
import { PopNotificationProps } from './components/PopNotification/PopNotification.component';
import utils from 'utils';

export type Notification = Omit<PopNotificationProps, 'notId'> & {
  content: React.ReactNode;
};

type PopNotificationsContextProps = {
  popInfo: (conf: Notification) => void;
  popSuccess: (content: string | ReactNode, onClick?: () => void) => void;
  popError: (content: string | ReactNode, onClick?: () => void) => void;
};

export default createContext<PopNotificationsContextProps>({
  popInfo: utils.noop,
  popError: utils.noop,
  popSuccess: utils.noop,
});
